module.exports = __webpack_public_path__ + "img/stu_avatar_9.01170e1c.jpg";